import React from 'react';
import { Badge } from './ui/badge';
import { CheckCircle2, ShieldAlert, Activity } from 'lucide-react';

/**
 * Clearance (return-to-play) status badge.
 * Input shapes tolerated:
 *   - { availability: "Fit"|"Injured"|"In Recovery" }  (from coach-today rows)
 *   - { status: "Fit"|"Injured"|"In Recovery"|"Cleared" }
 *   - raw string
 * "Fit" is treated as "Cleared" (no active injury).
 */
const ClearanceBadge = ({ value, size = 'xs', showIcon = true, testId }) => {
  const raw =
    typeof value === 'string'
      ? value
      : (value?.status || value?.availability || '').toString();

  const normalized = raw.trim().toLowerCase();

  let label = 'Unknown';
  let Icon = Activity;
  let cls = 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300 border-gray-200 dark:border-gray-700';

  if (!normalized) {
    return null;
  }

  if (['fit', 'cleared', 'clear', 'available'].includes(normalized)) {
    label = 'Cleared';
    Icon = CheckCircle2;
    cls = 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800';
  } else if (normalized === 'injured') {
    label = 'Injured';
    Icon = ShieldAlert;
    cls = 'bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-300 border-red-200 dark:border-red-800';
  } else if (normalized === 'in recovery' || normalized === 'recovery') {
    label = 'In Recovery';
    Icon = Activity;
    cls = 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300 border-amber-200 dark:border-amber-800';
  }

  const sizeCls = size === 'sm' ? 'text-[11px] px-2 py-0.5' : 'text-[10px] px-1.5 py-0';

  return (
    <Badge className={`${cls} ${sizeCls} border font-medium inline-flex items-center gap-1`} data-testid={testId || 'clearance-badge'}>
      {showIcon ? <Icon size={10} /> : null}
      {label}
    </Badge>
  );
};

export default ClearanceBadge;
